import { Routes } from '@angular/router';
import {Base_Routes} from './base/base.routes';
import {baseAccessGuard} from './shared/guards/base-access.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'base' },
  {
    path: 'auth',
    loadChildren: () => {
      return import('./auth/auth.routes').then(
        (m) => m.Auth_Routes
      );
    },
  },
  {
    path: 'base',
    loadChildren: () => {
      return import('./base/base.routes').then(
        (m) => m.Base_Routes
      );
    },
    //canActivate:[baseAccessGuard]
  },
  { path: '**', pathMatch: 'full', redirectTo: 'auth' }
];
